import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ITheme } from '../../models/ITheme';

@Component({
  selector: 'theme-list',
  templateUrl: './theme-list.component.html',
  styleUrls: ['./theme-list.component.scss']
})
export class ThemeListComponent {
  @Input() themes: ITheme[];
  @Output() delete = new EventEmitter();
  @Output() edit = new EventEmitter();

}
